import {Component, Input, OnInit} from '@angular/core';
import {Moment} from 'moment';

@Component({
    selector: 'app-date-summary-field',
    templateUrl: './date-summary-field.component.html',
})
export class DateSummaryFieldComponent implements OnInit {

    @Input() date: Moment;
    @Input() label: string;

    constructor() {
    }

    ngOnInit() {
    }

}
